var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pin3D__Object",style:({ left: _vm.data.x + 'px', top: _vm.data.y + 'px' }),on:{"click":function($event){return _vm.GoToCard(_vm.data.id)}}},[_c('div',{staticClass:"Pin3D__Icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }